import { NODE_MENU_MARGIN } from '@constants/canvas/general';
import { ReactFlowId } from '@constants/entities/reports';

type ClampTopArgs = {
  desiredTop: number;
  menuHeight: number;
  paneTop: number;
  paneBottom: number;
  margin?: number;
};

export const clampTop = ({
  desiredTop,
  menuHeight,
  paneTop,
  paneBottom,
  margin = NODE_MENU_MARGIN,
}: ClampTopArgs): number => {
  const minTop = paneTop + margin;
  const maxTop = paneBottom - menuHeight - margin;

  if (maxTop <= minTop) return minTop;

  return Math.min(Math.max(desiredTop, minTop), maxTop);
};

type ClampLeftArgs = {
  desiredLeft: number;
  menuWidth: number;
  paneLeft: number;
  paneRight: number;
  margin?: number;
};

export const clampLeft = ({
  desiredLeft,
  menuWidth,
  paneLeft,
  paneRight,
  margin = NODE_MENU_MARGIN,
}: ClampLeftArgs): number => {
  const minLeft = paneLeft + margin;
  const maxLeft = paneRight - menuWidth - margin;

  if (maxLeft <= minLeft) return minLeft;

  return Math.min(Math.max(desiredLeft, minLeft), maxLeft);
};

type ClampMenuArgs = {
  desiredTop: number;
  desiredLeft: number;
  menuEl: HTMLElement | null;
  isFixed: boolean;
  margin?: number;
};

export type MenuPosition = {
  top: number;
  left: number;
};

// Fixed menus are placed in viewport coordinates, absolute ones relative to the
// pane, so only the origin differs — both must stay fully inside the pane.
export const clampMenuToPane = ({
  desiredTop,
  desiredLeft,
  menuEl,
  isFixed,
  margin = NODE_MENU_MARGIN,
}: ClampMenuArgs): MenuPosition => {
  const pane = document
    .querySelector(`#${ReactFlowId}`)
    ?.getBoundingClientRect();

  if (!menuEl || !pane) return { top: desiredTop, left: desiredLeft };

  const { width, height } = menuEl.getBoundingClientRect();
  const originTop = isFixed ? pane.top : 0;
  const originLeft = isFixed ? pane.left : 0;

  return {
    top: clampTop({
      desiredTop,
      menuHeight: height,
      paneTop: originTop,
      paneBottom: originTop + pane.height,
      margin,
    }),
    left: clampLeft({
      desiredLeft,
      menuWidth: width,
      paneLeft: originLeft,
      paneRight: originLeft + pane.width,
      margin,
    }),
  };
};
